import React from 'react';
import { getExchangeRateInfo, getExchangeRates } from '../utils/currency';

/**
 * Display current exchange rate
 * Optional component that can be placed anywhere
 */
const ExchangeRateDisplay = ({ className = '', size = 'sm' }) => {
  const rates = getExchangeRates();
  const rate = Math.round(rates.USD_TO_JPY);
  
  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base'
  };

  return (
    <div className={`inline-flex items-center gap-2 text-slate-600 ${sizeClasses[size]} ${className}`}>
      <span className="font-medium">Exchange Rate:</span>
      <span className="font-semibold text-emerald-600">$1 = ¥{rate}</span>
      <span className="text-xs text-slate-400">(Live)</span>
    </div>
  );
};

export default ExchangeRateDisplay;
